import React, { useState, useEffect, useRef } from "react";
import {
  Center,
  ScrollView,
  Text,
  Image,
  HStack,
  Stack,
  Box,
  VStack,
  Pressable,
  Button,
  Modal,
} from "native-base";
import { LinearGradient } from "expo-linear-gradient";
import {  TouchableOpacity,Dimensions,Animated,ImageBackground } from "react-native";
import { GlobalStyles } from "./../constants/styles";
import { useNavigation } from "@react-navigation/native";
import { useSelector } from "react-redux";
import { GlobalConstants } from "../constants/constants";
import BusinessMainPage from "./main/BusinessMainPage";
import CitizenMainPage from "./main/CitizenMainPage";
import CityGovMainPage from "./main/CityGovMainPage";
import EventMainPage from "./main/EventMainPage";
import CityLensMainPage from "./main/CityLensMainPage";
import ChamberOfCommerceMainPage from "./main/ChamberOfCommerceMainPage";
import AdvertiserMainPage from "./main/AdvertiserMainPage";
import {
  MaterialIcons,
  Ionicons,
  FontAwesome5,
  MaterialCommunityIcons,
} from "@expo/vector-icons";

function Home() {
  const navigation = useNavigation();

  let user = useSelector((state) => state.user.user);

  const [modalVisible, setModalVisible] = useState(false);

  const initialRef = useRef(null);

  const finalRef = useRef(null);
  

  const [currentIndex, setCurrentIndex] = useState(0);
  const features = [
  {
    id: 1,
    title: "City Updates",
    icon: (
      <Image
      source={require("../../assets/Home/cityUpdates.png")}
      alt="No hate speech"
      w={isMobile ? "30px" : "50px"}
      h={isMobile ? "30px" : "50px"}
      resizeMode="contain"
    />
    ),
    description:
      "Discover upcoming events, time-sensitive deals, and newly opened local food and retail.",
  },
  {
    id: 2,
    title: "Business Updates",
    icon: (
      <Image
      source={require("../../assets/Home/business.png")}
      alt="No hate speech"
      w={isMobile ? "30px" : "50px"}
      h={isMobile ? "30px" : "50px"}
      resizeMode="contain"
    />
    ),
    description:
      "Stay connected with a personalized business updates feed from local and international brands.",
  },
  {
    id: 3,
    title: "City Government Updates",
    icon: (
      <Image
      source={require("../../assets/Home/cityGovUpdates.png")}
      alt="No hate speech"
      w={isMobile ? "30px" : "50px"}
      h={isMobile ? "30px" : "50px"}
      resizeMode="contain"
    />
    ),
    description:
      "Never miss critical City Gov updates. TownTicks offers a dedicated city government newsfeed for traffic alerts, taxes, security, and more.",
  },
  {
    id: 4,
    title: "New & Trending Products",
    icon: (
      <Image
      source={require("../../assets/Home/trending.png")}
      alt="No hate speech"
      w={isMobile ? "30px" : "50px"}
      h={isMobile ? "30px" : "50px"}
      resizeMode="contain"
    />
    ),
    description:
      "Choose your favorite product categories, and discover the latest trends, top products, and fresh new arrivals in dedicated product newsfeed.",
  },
];

const extraFeatures = [
  {
    id: 1,
    title: "Citizen Alerts:",
    description:
      "From Citizens to tell something important about city to fellow citizens",
  },
  {
    id: 2,
    title: "City Lens:",
    description:
      "Your city from the eyes of influencers making you discover good things and places in the city",
  },
];

const responsibleFeatures = [
  {
    id: 1,
    title: "Non addictive\nbusiness model",
    icon: (
      <Image
      source={require("../../assets/Home/addiction.png")}
      alt="No hate speech"
      w="37px"
      h="37px"
      resizeMode="contain"
      />
    ),
  },
  {
    id: 2,
    title: "No fake content",
    icon: (
      <Image
      source={require("../../assets/Home/fake.png")}
      alt="No hate speech"
      w="37px"
      h="37px"
      resizeMode="contain"
      />
    ),
  },
  {
    id: 3,
    title: "Safe for all ages",
    icon: (
      <Image
      source={require("../../assets/Home/safe.png")}
      alt="No hate speech"
      w="37px"
      h="37px"
      resizeMode="contain"
      />
    ),
  },
  {
    id: 4,
    title: "No hate speech",
    icon: (
      <Image
      source={require("../../assets/Home/hate.png")}
      alt="No hate speech"
      w="37px"
      h="37px"
      resizeMode="contain"
      />
    ),
  },
  {
    id: 5,
    title: "No targeted ads",
    icon: (
      <Image
      source={require("../../assets/Home/target.png")}
      alt="No hate speech"
      w="37px"
      h="37px"
      resizeMode="contain"
      />
    ),
  },
];
const content = [
  {
    title: "City Updates",
    text: "Discover upcoming events, time-sensitive deals, and newly opened local food and retail.",
    image: require("../../assets/Home/city-updates.png"),
  },
  {
    title: "Business Updates",
    text: "Stay connected with a personalized business updates feed from local and international brands.",
    image: require("../../assets/Home/business-updates.png"),
  },
  {
    title: "City Government Updates",
    text: "Never miss critical City Gov updates. TownTicks offers a dedicated city government newsfeed for information like traffic alerts, taxes, security, and more.",
    image: require("../../assets/Home/city-government-updates.png"),
  },
  {
    title: "New & Trending Products",
    text: "If you’re looking to buy something, select a product category. Based on your selection, we’ll show you a feed of popular or trending products and a feed of the latest product launches, available in your city.",
    image: require("../../assets/Home/trending-products.png"),
  },
];
const InfoCard = ({ item, isMobile }) => {
  return (
    <VStack
      alignItems="center"
      space={3}
      px={4}
      py={5}
      w={isMobile ? "100%" : "70%"}
      alignSelf="center"
      space={12}
    >
      <HStack
        alignItems="center"
        justifyContent="center"
        space={6}
      >
        <Box>{item.icon}</Box>

        <Text
          fontSize={isMobile ? "20px" : "44px"}
          color="#22004B"
          fontWeight="600"
          textAlign="center"
          letterSpacing={-1.6}
          fontFamily="Inter-SemiBold"
        >
          {item.title}
        </Text>
      </HStack>

      <Text
        fontSize={isMobile ? "15px" : "20px"}
        color="#000000"
        fontFamily="Inter-Medium"
        fontWeight="500"
        lineHeight="32px"
        textAlign="center"
        letterSpacing={0}
      >
        {item.description}
      </Text>
    </VStack>
  );
};

const ResponsibleCard = ({ item, isMobile }) => {
  return (
    <VStack
      borderWidth={1}
      borderColor="#22004B"
      borderRadius="8px"
      px={3}
      py={4}
      mt={2}
      w={isMobile ? "135%" : "220px"}
      minH="230px"
      justifyContent="center"
      space={3}
      bg="#FFFFFF"
      
    >
      <Box
        w="80px"
        h="80px"
        borderRadius="full"
        bg="#22004B"
        position="absolute"
        top={6}
        alignSelf="center"
        alignItems="center"
        justifyContent="center"
      >
        {item.icon}
      </Box>
    <Box flex={1}
      // justifyContent="center"
      // alignItems="center"
      alignSelf="center"
      position="absolute"
      bottom={10}
      >
      <Text
        fontSize="25px"
        color="#22004B"
        fontWeight="300"
        lineHeight="34.8px"
        fontFamily="Inter-light"
      >
        {item.title}
      </Text>
    </Box>
    </VStack>
  );
};
const { width } = Dimensions.get("window");

  const isMobile = width < 768;

  // 🚀 Move to Next Item (Circular)
  const handlePrev = () => {
    const nextIndex = (currentIndex + 1) % carouselData.length; // Circular move
    setCurrentIndex(nextIndex);
    Animated.timing(translateX, {
      toValue: -nextIndex * (ITEM_WIDTH + ITEM_SPACING),
      duration: 500, // Smooth animation
      useNativeDriver: true,
    }).start();
  };

  useEffect(async () => {
    console.log(window?.innerHeight);
    if (user && user.is_new_user) {
      navigation.navigate("Settings");
    }
  }, []);

  return (
    <>
      {user && user.user_category == GlobalConstants.userCategories.guest.id ? (
        <CitizenMainPage />
      ) : user &&
        user.user_category == GlobalConstants.userCategories.citizen.id ? (
        <CitizenMainPage />
      ) : user &&
        user.user_category == GlobalConstants.userCategories.business.id ? (
        <BusinessMainPage />
      ) : user &&
        user.user_category ==
          GlobalConstants.userCategories.cityGovernment.id ? (
        <CityGovMainPage />
      ) : user &&
        user.user_category ==
          GlobalConstants.userCategories.chamberOfCommerce.id ? (
        <ChamberOfCommerceMainPage />
      ) : user &&
        user.user_category == GlobalConstants.userCategories.advertiser.id ? (
        <AdvertiserMainPage />
      ) : user &&
        user.user_category ==
          GlobalConstants.userCategories.eventOrganizer.id ? (
        <EventMainPage />
      ) : user &&
        user.user_category ==
          GlobalConstants.userCategories.cityLens.id ? (
        <CityLensMainPage />
      ): (
         <ScrollView
          flex={1}
          // bg="#F4F1EF"
          showsVerticalScrollIndicator={false}
        >
          {/* ================= HERO SECTION ================= */}

          {/* <LinearGradient
            colors={["#FFE69D", "#ffe16d", "#FFE289"]}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 1 }}
            style={{
              paddingTop: isMobile ? 30 : 50,
              paddingBottom: isMobile ? 50 : 90,
              paddingHorizontal: isMobile ? 20 : 40,
            }}
          > */}
            <ImageBackground
            source={require("../../assets/Home/hero.png")}
            resizeMode="stretch"
            style={{
              width: "100%",
            }}
          >
            {/* HERO CONTENT */}
            <VStack alignItems="center" space={5}>
              <Text
                fontSize={isMobile ? "18px" : "50px"}
                fontWeight="800"
                color="#22004B"
                textAlign="center"
                fontFamily="Inter-SemiBold"
                lineHeight={isMobile ? 38 : 78}
                letterSpacing={-1.96}
              >
                Stay in Touch with Your City & Your Favorite Businesses
              </Text>

              <Text
               mt={isMobile ? 6 : 8}
               w={isMobile ? "100%" : "48%"}
                textAlign="center"
                color="#4E336F"
                fontWeight="400"
                fontFamily="Inter-Regular"
                fontSize={isMobile ? "13px" : "18px"}
                lineHeight={isMobile ? 22 : 34}
              >
                Most social networks emphasize global, entertainment-focused content across
many topics to keep users addictive. Local city information often slips by.
TownTicks helps you discover and share local information with family and friends.

              </Text>

              <Pressable
                mt={3}
                bg="#22004B"
                px={8}
                py={3}
                mb={2}
                borderRadius="5px"
                onPress={() => navigation.navigate("SignUp")}
              >
                <Text color="#fff" fontWeight="600">
                  Sign Up
                </Text>
              </Pressable>
            </VStack>
          </ImageBackground>
          {/* </LinearGradient> */}

          {/* ================= WHITE INFO SECTION ================= */}
          <ImageBackground
            source={require("../../assets/Home/background.png")}
            resizeMode="stretch"
            style={{
              width: "100%",
            }}
          >
         <Box w="100%" py={{ base: 6, md: 10 }}>
              <VStack space={12} mt={9}>
              {/* CITY IMAGE */}
              <Image
                source={require("../../assets/Home/pic-2.png")}
                alt="city"
                resizeMode="contain"
                alignSelf="center"
                w={isMobile ? "300px" : "520px"}
                h={isMobile ? "180px" : "320px"}
              />
                
                 {/* SECTION TITLE */}
                <Text
                  textAlign="center"
                  color="#FFC000"
                  fontFamily="Inter"
                  fontWeight="500"
                  fontSize={{
                    base: "22px",
                    sm: "26px",
                    md: "32px",
                    lg: "40px",
                  }}
                  lineHeight={{
                    base: "30px",
                    md: "40px",
                    lg: "45px",
                  }}
                  mb={{ base: 6, md: 10 }}
                >
                  A Social Network About Your City
                </Text>

                {/* CONTENT */}
                <VStack w="100%" >
                  {content.map((item, index) => (
                    <Box key={index} w="100%" mt={10}>

                      {/* TEXT */}
                      <Box
                        w="100%"
                        px={{ base: 5, md: 10, lg: 16 }}
                        alignItems="center"
                      >
                        <Text
                          textAlign="center"
                          color="#25005C"
                          fontFamily="Inter"
                          fontWeight="600"
                          fontSize={{
                            base: "19px",
                            sm: "21px",
                            md: "25px",
                            lg: "35px",
                          }}
                          lineHeight={{
                            base: "26px",
                            md: "32px",
                            lg: "38px",
                          }}
                          mb={2}
                        >
                          {item.title}
                        </Text>

                        <Text
                          w="100%"
                          maxW="752px"
                          mt={5}
                          textAlign="center"
                          color="#000000"
                          fontFamily="Inter"
                          fontWeight="400"
                          fontSize={{
                            base: "13px",
                            sm: "14px",
                            md: "16px",
                            lg: "20px",
                          }}
                          lineHeight={{
                            base: "20px",
                            md: "24px",
                            lg: "27px",
                          }}
                        >
                          {item.text.trim()}
                        </Text>
                      </Box>

                      {/* IMAGE */}
                      <Box
                        w="100%"
                        alignItems="center"
                        justifyContent="center"
                        mt={{ base: 5, md: 8 }}
                        mb={{ base: 6, md: 8 }}
                      >
                        <Image
                          source={item.image}
                          alt={item.title}
                          resizeMode={isMobile ? "cover" : "contain"}
                          w={{
                            base: "100vw",
                            sm: "480px",
                            md: "740px",
                            lg: "1300px",
                          }}
                          h={{
                            base: "220px",
                            sm: "220px",
                            md: "600px",
                            lg: "900px",
                          }}
                        />
                      </Box>

                      {/* DIVIDER */}
                      {index < content.length - 1 && (
                        <Box
                          w="50%"
                          h="1px"
                          bg="#F4B400"
                          alignSelf="center"
                        />
                      )}

                    </Box>
                  ))}
                </VStack>
              </VStack>
            </Box>
          </ImageBackground>
           

          {/* ================= RESPONSIBLE SOCIAL ================= */}

          <VStack
            px={isMobile ? 4 : 12}
            py={14}
            alignItems="center"
            space={5}
          >
            <HStack alignItems="center" space={2} mt={10}>
              
                <Image
                  source={require("../../assets/Home/star.png")}
                  alt="No hate speech"
                  w={isMobile ? "30px" : "60px"}
                  h={isMobile ? "30px" : "60px"}
                  resizeMode="contain"
                />
              

              <Text
                fontSize={isMobile ? "22px" : "48px"}
                fontWeight="600"
                color="#3A1367"
                fontFamily="Inter-SemiBold"
                ml={2}
              >
                A Responsible Social Media
              </Text>
            </HStack>

           <Text
  textAlign="center"
  alignSelf="center"
  color="#777"
  lineHeight={32}
  fontSize={isMobile ? "14px" : "24px"}
  w={isMobile ? "100%" : "75%"}
  fontFamily="Inter-Medium"
  fontWeight="500"
  mt={8}
>
  Local city information helps us navigate everyday life.{"\n"}
  Social media like TownTicks helps to get that information and pass on to family & friends.
  We do not store any personal names or personal data. We work with user names or nicks. Our responsible social media standards make sure our platform is safe for everyone.
</Text>

            {/* RESPONSIBLE CARDS */}
            <HStack
              flexWrap="wrap"
              justifyContent="center"
              space={isMobile ? 2 : 4}
              mt={5}
            >
              {responsibleFeatures.map((item) => (
                <ResponsibleCard
                  key={item.id}
                  item={item}
                  isMobile={isMobile}
                />
              ))}
            </HStack>
          </VStack>

          {/* ================= FOOTER IMAGE ================= */}

          <Box mt={10}>
            <Image
              source={require("../../assets/Home/meetup.png")}
              alt="footer"
              w="100%"
              h={isMobile ? "380px" : "534px"}
              resizeMode="cover"
            />

            <HStack
              bg="#373737"
              px={6}
              py={4}
              justifyContent="space-between"
              alignItems="center"
            >
              <Text color="#fff" fontSize="12px" fontFamily={GlobalStyles.text.fontFamily}>
                TownTicks is a product of Novelma Inc.
              </Text>

              <Pressable onPress={() => setModalVisible(!modalVisible)}>
                <Text color="#fff" fontSize="12px" fontFamily={GlobalStyles.text.fontFamily}>
                  Contact Us
                </Text>
              </Pressable>
            </HStack>
          </Box>
        </ScrollView>
      )}

      <Modal
        isOpen={modalVisible}
        onClose={() => setModalVisible(false)}
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
      >
        <Modal.Content>
          <Modal.CloseButton />
          <Modal.Header>Contact Us</Modal.Header>
          <Modal.Body>
            <Text>
              To contact or any feedback about TownTicks, write to
              <Text color={GlobalStyles.colors.blue}>
                {" "}
                support.townticks@novelma.com
              </Text>
            </Text>
          </Modal.Body>
          <Modal.Footer>
            <Button.Group space={2}>
              <Button
                variant="ghost"
                colorScheme="blueGray"
                onPress={() => {
                  setModalVisible(false);
                }}
              >
                Close
              </Button>
            </Button.Group>
          </Modal.Footer>
        </Modal.Content>
      </Modal>
    </>
  );
}

export default Home;
